import {
  countriesInfo,
  CountryCode,
  CountryInfo,
  defaultGeoLocationData,
} from '../countries';
import { isValidCountryCode } from '../isValidCountryCode';

export const getCountryInfoFromCountryCode = (
  countryCode: string,
  fallBackCountryCode: CountryCode = defaultGeoLocationData.countryCode
): CountryInfo => {
  return isValidCountryCode(countryCode)
    ? countriesInfo[countryCode]
    : countriesInfo[fallBackCountryCode];
};
